import React from "react";
import { Link } from "react-router-dom";

export const faqColumns = (handleEdit, handleDelete, PAGE_SIZE) => [
   {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Question",
    render: (row) => 
        <span>
          {row.question}
        </span>,    
  }
  ,
  {
    label: "Answer",
    render: (row) => 
        <span>
          {row.answer}
        </span>,    
  },
  {
    label: "Status",
    render: (row) => (
      <div className="checkbox-wrapper-8">
        <input
          className="tgl tgl-skewed"
          type="checkbox"
          checked={row.status === "Active"}
          readOnly
        />
        <label
          className="tgl-btn"
          data-tg-off="Inactive"
          data-tg-on="Active"
        />
      </div>
    ),
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <Link  onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </Link>
        </li>
        <li>
          <Link  onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li>
      </ul>
    ),
  },
  
  
];
